// extracted by mini-css-extract-plugin
export default {"page":"styles_page__-F7vQ","button":"styles_button__sSQ31","content":"styles_content__Co2EJ"};